function QueueWatcher(selectedQueuesObservable) {
  this.watchInterval = null;
  this.intervalDurationMs = 1000 * 60;
  this.staleThreshold = 60;
  this.queues = selectedQueuesObservable;

  this.isStaleQueue = function (queue) {
    return queue.timeSinceLastUpdate() >= this.staleThreshold;
  }

  /**
   * Update Queues that haven't been recently updated
   */
  this.updateStaleQueues = function() {
    this.staleQueues().forEach(function (queue) {
      queue.updateAllSpots();
    })
  }

  this.staleQueues = function() {
    return this.queues().filter(this.isStaleQueue.bind(this));
  }

  this.beginWatch = function() {
    this.watchInterval = setInterval(function () {
      this.updateStaleQueues()
    }.bind(this), this.intervalDurationMs)
  }

  this.endWatch = function() {
    clearInterval(this.watchInterval)
  }
}

module.exports = QueueWatcher;
